<script>
  import { TimePicker } from "carbon-components-svelte";

  export let von = "hh:mm";
  export let bis = "hh:mm";
  export let invalidVon = false;
  export let invalidBis = false;
  export let label = "";
  export let id = "";
  export let labelVon = "";
  export let labelBis = "";
  export let required = false;
  export let timeZeit = {};
  export let rowId;
  export let isEmpty = false;
  export let inTable = false;
  export let updateCellValue = () => {};

  export let handleTimeVon = (e) => {
    von = e.target.value;
    if (!e.target.validity.valid && von !== "hh:mm") {
      invalidVon = true;
    } else {
      invalidVon = false;
      updateCellValue();
    }
  };

  export let handleTimeBis = (e) => {
    bis = e.target.value;
    if (!e.target.validity.valid && bis !== "hh:mm") {
      invalidBis = true;
    } else {
      invalidBis = false;
      updateCellValue();
    }
  };

  const timePattern = "^([01]\\d|2[0-3]):([0-5]\\d)$";

  $: {
    if (rowId && inTable) {
      timeZeit[rowId] = {
        von: von,
        bis: bis,
      };
    }
  }

  $: {
    if (von !== "hh:mm" && bis !== "hh:mm" && !invalidVon && !invalidBis) {
      updateCellValue();
    }
  }
</script>

<div>
  {#if label}
    <label for={id}>{label}{required ? "*" : ""}</label>
  {/if}
  <div
    id="time-picker-{inTable ? '' : rowId}"
    style="display: flex; align-items: center;"
    class="time-picker"
    class:isEmpty
  >
    <TimePicker
      placeholder="hh:mm"
      label={labelVon}
      size="sm"
      light
      value={von}
      on:change={handleTimeVon}
      pattern={timePattern}
      invalid={invalidVon}
    />
    <span>-</span>
    <TimePicker
      placeholder="hh:mm"
      label={labelBis}
      size="sm"
      light
      value={bis}
      on:change={handleTimeBis}
      pattern={timePattern}
      invalid={invalidBis}
    />
  </div>
</div>

<style>
  label {
    display: block;
    margin-bottom: 0.5rem;
    font-size: 0.875rem;
    font-weight: 700;
    color: #1f2937;
  }

  :global(.time-picker .bx--time-picker__input-field) {
    padding-right: 10px;
    padding-left: 10px;
    width: 65px;
  }

  :global(.time-picker .bx--form-item) {
    align-items: center;
    justify-content: center;
    width: 65px;
  }

  :global(.time-picker .bx--text-input--invalid) {
    border-color: red;
  }

  .isEmpty {
    border: solid 1px red;
  }
</style>
